<template>
  <div class="hidden-input" @click.stop>
    <div
      @paste="handlePaste"
      contenteditable="true"
      ref="contentEditableDiv"
      class="visitor-image"
    ></div>
    <atom-input v-model="visitorInfo.firstname"></atom-input>
    <atom-input v-model="visitorInfo.lastname"></atom-input>
    <atom-input v-model="visitorInfo.idType"></atom-input>
    <atom-input v-model="visitorInfo.idNumber"></atom-input>
    <atom-input v-model="visitorInfo.expiredDate"></atom-input>
    <atom-input v-model="visitorInfo.nationality"></atom-input>
    <atom-text-area v-model="visitorInfo.address" :rows="1"></atom-text-area>
    <atom-button
      buttonId="finish-reading-data-btn"
      @click="clickFinishReadingData"
      >Confirm</atom-button
    >
  </div>
</template>

<script>
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
export default {
  name: "MoleculeHiddenSelfCheckInInput",

  components: {
    AtomButton,
    AtomInput,
    AtomTextArea,
  },

  props: {
    redirectTime: {
      type: Number,
      required: true,
    },
    counterClearVisitorInfo: {
      type: Number,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
  },

  emits: ["onFinishReadingVisitorInfo"],

  computed: {
    visitorInfo: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit("input", newValue)
      },
    },
  },

  watch: {
    counterClearVisitorInfo() {
      this.setDefaultInput()
    },
  },

  mounted() {
    this.setFocusToImageContainer()
  },

  methods: {
    setDefaultInput() {
      this.clearPastedImage()
      this.setFocusToImageContainer()
    },

    setFocusToImageContainer() {
      if (this.$refs.contentEditableDiv) {
        this.$refs.contentEditableDiv.focus()
      }
    },

    handlePaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData

      if (clipboardData) {
        const items = clipboardData.items
        for (let i = 0; i < items.length; i++) {
          if (items[i].type.indexOf("image") !== -1) {
            const blob = items[i].getAsFile()

            // Convert blob to File
            const imageFile = new File([blob], "jpg", {
              type: blob.type,
            })

            // Update visitorImage with the image URL
            this.visitorInfo.visitorImage = imageFile

            this.clearPastedImage()
          }
        }
      }
    },

    clearPastedImage() {
      if (this.$refs.contentEditableDiv) {
        this.$refs.contentEditableDiv.innerHTML = ""
      }
    },

    clickFinishReadingData() {
      if (this.redirectTime === 0) {
        this.$emit("onFinishReadingVisitorInfo")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.hidden-input {
  position: absolute;
  opacity: 0;
}

.visitor-image {
  height: 160px;
  width: 128px;
  overflow: hidden;
}
</style>
